// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e1-3";
export var flatBottomCorners = "_e1-5";
export var productImage = "_e1-0";
export var quantityContainer = "_e1-2";
export var quantityHeader = "_e1-6";
export var tooltip = "_e1-1";
export var wrapAndEllipsesOverflow = "_e1-4";